export default "I spend a signficiant amount of my time in the mobile space developing mobile applications. If you are in need of a specialist, feel free to contact me at alex@alexharrison.dev."

